// extracted by mini-css-extract-plugin
module.exports = {"casesContainer":"CasesServices_casesContainer__V0Aw9","lastWords":"CasesServices_lastWords__No2Y4"};